import Vue from 'vue';
import {
  // Button,
  // Icon,
  // // Toast,
  // Loading,
  // Image,
  // Cell,
  // Empty,
  // // Dialog,
  // Checkbox,
  // Field,
  // Picker,
  // Popup,
  // Image as VanImage,
  // Progress,
  // Popover,
  // DatetimePicker,
  // Swipe,
  // SwipeItem,
  Collapse,
  CollapseItem,
} from 'vant';

// Vue.use(Button)
//   .use(Icon)
//   // .use(Toast)
//   .use(Loading)
//   .use(Image)
//   .use(Cell)
//   .use(Empty)
//   .use(Field)
//   .use(Checkbox)
//   .use(Picker)
//   .use(Popup)
//   // .use(Dialog)
//   .use(VanImage)
//   .use(Progress)
//   .use(DatetimePicker)
//   .use(Popover)
//   .use(Swipe)
//   .use(SwipeItem)
//   .use(Collapse)
//   .use(CollapseItem);
Vue.use(Collapse)
  .use(CollapseItem);
